import { Box } from '@mui/material';
import grassImg from '../assets/grass.jpg';
import waterImg from '../assets/water.jpg';
import stoneImg from '../assets/stone.jpg';
import sandImg from '../assets/sand.jpg';
import concreteImg from '../assets/concrete.jpg';
import woodImg from '../assets/wood.jpg';
import dirtImg from '../assets/dirt.jpg';
import doorImg from '../assets/door.png';
import tableImg from '../assets/table.png';
import tableRoundImg from '../assets/tableround.png';
import chestImg from '../assets/chest.png';
import trapDoorImg from '../assets/trapdoor.png';
import bedImg from '../assets/bed.png';
import bedrollImg from '../assets/bedroll.png';
import sackImg from '../assets/sack.png';
import bucketImg from '../assets/bucket.png';
import stoolImg from '../assets/stool.png';
import barrelImg from '../assets/barrel.png';
import bookshelfImg from '../assets/bookshelf.png';
import wardrobeImg from '../assets/wardrobe.png';
import crateImg from '../assets/cratebox.png'; 
import cratePileImg from '../assets/cratepile.png';
import chairImg from '../assets/chair.png';
import throneImg from '../assets/throne.png';
import campfireImg from '../assets/campfire.png';
import campfireOutImg from '../assets/campfireout.png';
import tentImg from '../assets/tent1.png';
import tent2Img from '../assets/tent2.png';
import stairsWoodDownImg from '../assets/stairswooddown.png';
import stairsWoodUpImg from '../assets/stairswoodup.png';
import stairsStoneDownImg from '../assets/stairsstonedown.png';
import stairsStoneUpImg from '../assets/stairsstoneup.png';

export const PAINT_MODE = {
    LINE: 'LINE',
    AREA: 'AREA',
  };
  
  export const PAINT_CATEGORY = {
    TERRAIN: 'TERRAIN',
    OBJECTS: 'OBJECTS',
    STRUCTURE: 'STRUCTURE',
    FOG: 'FOG',
    ERASE: 'ERASE',
  };

export const PAINT_COLORS = [
    {
      name: 'Grass',
      color: '#4CAF50',
      image: grassImg,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${grassImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Water',
      color: '#2196F3',
      image: waterImg,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${waterImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Stone',
      color: '#9E9E9E',
      image: stoneImg,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${stoneImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Sand',
      color: '#FDD835',
      image: sandImg,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${sandImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    { 
      name: 'Wood', 
      color: '#8D6E63', 
      image: woodImg,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${woodImg})`,
            backgroundSize: 'cover'
          }}
        />
      )},
    { 
      name: 'Dirt', 
      color: '#795548', 
      image: dirtImg,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${dirtImg})`,
            backgroundSize: 'cover'
          }}
        />
      )},
    { 
      name: 'Concrete', 
      color: '#BDBDBD', 
      image: concreteImg,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${concreteImg})`,
            backgroundSize: 'cover'
          }}
        />
      )},
  ];
  
  export const FOG_ITEMS = [
    {
      name: 'Add Fog',
      color: { fog: true },
      description: 'Hide areas of the map from players. Can be drawn over terrain and objects',
      type: 'fog'
    },
    {
      name: 'Clear Fog',
      color: { clearFog: true },
      description: 'Remove fog of war from selected areas to reveal the map to players',
      type: 'clearFog'
    },
  ];
  
  export const ERASE_ITEMS = [
    {
      name: 'Erase Terrain',
      color: { clearColor: true, eraseType: 'terrain' },
      description: 'Remove terrain paint from the grid',
      type: 'eraseTerrain'
    },
    {
      name: 'Erase Objects',
      color: { clearColor: true, eraseType: 'objects' },
      description: 'Remove objects from the grid',
      type: 'eraseObjects'
    },
    {
      name: 'Erase Structures',
      color: { clearColor: true, eraseType: 'walls' },
      description: 'Remove structure segments from grid lines',
      type: 'eraseWalls'
    },
  ];
  
  export const OBJECT_ITEMS = [
    {
      name: 'Table',
      color: 'table-object',
      image: tableImg,
      defaultWidth: 2,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${tableImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Table Round',
      color: 'table-round-object',
      image: tableRoundImg,
      defaultWidth: 2,
      defaultHeight: 2,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${tableRoundImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Crate',
      color: 'crate-object',
      image: crateImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${crateImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Crate Pile',
      color: 'crate-pile-object',
      image: cratePileImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${cratePileImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Chair',
      color: 'chair-object',
      image: chairImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${chairImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Bed',
      color: 'bed-object',
      image: bedImg,
      defaultWidth: 1,
      defaultHeight: 2,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${bedImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Bedroll',
      color: 'bedroll-object',
      image: bedrollImg,
      defaultWidth: 1,
      defaultHeight: 2,
      renderHeight: 1.5,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${bedrollImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Sack',
      color: 'sack-object',
      image: sackImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${sackImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Stool',
      color: 'stool-object',
      image: stoolImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${stoolImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Barrel',
      color: 'barrel-object',
      image: barrelImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${barrelImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    { 
      name: 'Bookshelf',
      color: 'bookshelf-object',
      image: bookshelfImg,
      defaultWidth: 2,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${bookshelfImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Wardrobe',
      color: 'wardrobe-object',
      image: wardrobeImg,
      defaultWidth: 2,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${wardrobeImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },  
    {
      name: 'Campfire',
      color: 'campfire-object',
      image: campfireImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${campfireImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Campfire Out',
      color: 'campfire-out-object',
      image: campfireOutImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${campfireOutImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Tent',
      color: 'tent-object',
      image: tentImg,
      defaultWidth: 2,
      defaultHeight: 2,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${tentImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Tent 2',
      color: 'tent-2-object',
      image: tent2Img,
      defaultWidth: 2,
      defaultHeight: 2,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${tent2Img})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Throne',
      color: 'throne-object',
      image: throneImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${chestImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Bucket',
      color: 'bucket-object',
      image: bucketImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${bucketImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Chest',
      color: 'chest-object',
      image: chestImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${chestImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Trap Door',
      color: 'trap-door-object',
      image: trapDoorImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${trapDoorImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Stairs Wood Down',
      color: 'stairs-wood-down-object',
      image: stairsWoodDownImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${stairsWoodDownImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Stairs Wood Up',
      color: 'stairs-wood-up-object',
      image: stairsWoodUpImg,
      defaultWidth: 2,
      defaultHeight: 1,
      renderWidth: 1.5,
      renderHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${stairsWoodUpImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Stairs Stone Down',
      color: 'stairs-stone-down-object',
      image: stairsStoneDownImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${stairsStoneDownImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
    {
      name: 'Stairs Stone Up',
      color: 'stairs-stone-up-object',
      image: stairsStoneUpImg,
      defaultWidth: 1,
      defaultHeight: 1,
      preview: (
        <Box 
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${stairsStoneUpImg})`,
            backgroundSize: 'cover'
          }}
        />
      )
    },
  ];
  
  export const STRUCTURE_ITEMS = [
    {
      name: 'Wall',
      color: { structure: 'wall' },
      description: 'Draw black wall segments snapped to grid lines',
      type: 'wall',
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            background: 'rgba(255, 255, 255, 0.08)',
            borderRadius: '4px',
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              left: '12%',
              right: '12%',
              top: '46%',
              height: '3px',
              borderRadius: '2px',
              backgroundColor: '#000000',
            },
          }}
        />
      )
    },
    {
      name: 'Door',
      color: { structure: 'door' },
      description: 'Draw door segments snapped to grid lines',
      image: doorImg,
      textureKey: 'structure-door',
      type: 'door',
      preview: (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${doorImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      )
    },
  ];
  